// The remote's imperative session surface (its ./session expose), probed
// once at module scope: present on current remote builds, absent on older
// ones. On a miss the switch flow falls back to a document reload, which
// needs no remote cooperation — so shell and remote can deploy in either
// order.
export const remoteSession = await import('remote/session').catch(() => null);
